import Dialog from '@components/atoms/dialog/dialog';
import Icon from '@components/atoms/icon/icon';
import { ListingContext } from '@context/listing.context';
import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useContextSelector } from 'use-context-selector';
import styles from '../index.module.scss';
import ModelsModal from './models-modal';

interface ModelsSelectPropsInterface {
  isSubcatPlural: boolean;
}

interface SentencePartInterface {
  isSubcatPlural?: boolean;
  variant?: 'a' | 'b';
}

const SentencePart3: React.FC<SentencePartInterface> = ({ isSubcatPlural }) => {
  const { t } = useTranslation('pricing-calculator');
  return (
    <span className={styles.formSentence__text}>
      {`${t(
        isSubcatPlural ? 'PRICING_CALCULATOR.SENTENCE.PART_3.PLURAL' : 'PRICING_CALCULATOR.SENTENCE.PART_3.SINGULAR',
      )} `}
    </span>
  );
};

const ModelsSelect: React.FC<ModelsSelectPropsInterface> = (props): React.JSX.Element => {
  const { isSubcatPlural } = props;

  const { t } = useTranslation('pricing-calculator');
  const { models, modelLabel, setPricingCalculatorInputTouched, setShowDefaultPricingCalculatorMessage } =
    useContextSelector(ListingContext, (state) => state);

  const [isModelsModalOpen, setIsModelsModalOpen] = useState<boolean>(false);

  const closeDialog = (argument) => {
    setIsModelsModalOpen(argument);
  };

  if (!models.length) {
    return null;
  }

  return (
    <>
      <div>
        <SentencePart3 isSubcatPlural={isSubcatPlural} />
        <button
          data-cy="models-select"
          className={styles.formSentence__selectLikeButton}
          onClick={() => {
            setIsModelsModalOpen(true);
            setPricingCalculatorInputTouched(true);
            setShowDefaultPricingCalculatorMessage(false);
          }}
          tabIndex={0}
          type="button"
        >
          {modelLabel || t('PRICING_CALCULATOR.MODEL_SELECTION.SELECT_LABEL_DEFAULT')}
          <Icon
            className={styles.formSentence__selectLikeButton__icon}
            name="ios-arrow-down-20"
          />
        </button>
      </div>
      <Dialog
        closeDialog={closeDialog}
        key={`${isModelsModalOpen}`}
        isOpen={isModelsModalOpen}
        hasCloseIcon
        styles={{
          content: {
            maxWidth: '660px',
            width: '100%',
          },
        }}
      >
        <ModelsModal setIsModelsModalOpen={setIsModelsModalOpen} />
      </Dialog>
    </>
  );
};

export default ModelsSelect;
